import React, { useEffect ,useState} from 'react';
import { Modal } from 'react-bootstrap';
import { message } from "antd";
import { isNullUndefine, formatDateIntoDDMMYY, formatDateNew } from '../../control/Constant';
import Services from '../../network/Services';


function EmailHistoryGrid({ historyData, openId, setOpenId, loading, lastItemRef }) {

    const toggle = (id) => setOpenId(openId === id ? null : id);


    const getColor = (status) => {
        switch (status) {
            case "ACTIVE":   return "green";
            case "EXPIRED":  return "red";
            case "NO AMA":   return "black";
            case "FREE AMA": return "orange";
            default:         return "#333";
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: "1rem" }}>
            {!isNullUndefine(historyData) && historyData?.length > 0 ? historyData?.map((item, index) => {
                const isLast = index === historyData.length - 1;
                return (   // ← this was missing
                    <div
                        key={item.emailHistoryId}
                        ref={isLast ? lastItemRef : null}
                        style={{
                            background: "#fff",
                            border: "1px solid #333333",
                            borderRadius: 5,
                            overflow: "hidden",
                        }}
                    >
                        {/* ── Header ── */}
                        <div className='d-flex justify-content-between'>
                            <div
                                style={{
                                    padding: "10px",
                                    borderBottom: "1px solid #e5e7eb",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        gap: 12,
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <div style={{ display: "flex", gap: 30, flexWrap: "wrap" }}>
                                        <div style={{ fontSize: 12, color: "#333" }}>
                                            Sent by - {item.emailSentBy}
                                        </div>
                                        <div style={{ fontSize: 12, color: "#333" }}>
                                            Sent on -{" "}
                                            <span style={{ fontWeight: 500, color: "#111" }}>
                                                {formatDateIntoDDMMYY(item.createdOn)}
                                            </span>
                                        </div>
                                        <div style={{ fontSize: 12, color: "#333" }}>
                                            Status as on{" "}
                                            <span style={{ fontWeight: 500, color: "#111" }}>
                                                {formatDateNew(item.createdOn)}
                                            </span>{" "}
                                            <span style={{ fontWeight: 600, color: getColor(item.occurrenceDescription) }}>
                                                {item.occurrenceDescription}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    title={item.emailSubject}
                                    style={{
                                        fontSize: 12,
                                        color: "#111",
                                        maxWidth: 600,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        cursor: "pointer",
                                    }}
                                >
                                    {item.emailSubject}
                                </div>
                            </div>

                            <div style={{ padding: "10px" }}>
                                <button
                                    onClick={() => toggle(item.emailHistoryId)}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.background = "#720d21";
                                        e.currentTarget.style.color = "#fff";
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.background = "transparent";
                                        e.currentTarget.style.color = "#720d21";
                                    }}
                                    style={{
                                        fontSize: 14,
                                        padding: "4px 12px",
                                        border: "1px solid #720d21",
                                        borderRadius: 2,
                                        background: "transparent",
                                        color: "#720d21",
                                        cursor: "pointer",
                                        height: "44px",
                                        transition: "background 0.2s, color 0.2s",
                                    }}
                                >
                                    {openId === item.emailHistoryId ? "Close" : "Preview"}
                                </button>
                            </div>
                        </div>

                        {/* ── Email Content Preview ── */}
                        {openId === item.emailHistoryId && (
                            <div
                                style={{
                                    padding: 16,
                                    background: "#f9fafb",
                                    overflowX: "auto",
                                    maxHeight: 340,
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <div
                                    style={{ transform: "scale(0.85)", transformOrigin: "top center", width: 600 }}
                                    dangerouslySetInnerHTML={{ __html: item.emailContent }}
                                />
                            </div>
                        )}
                    </div>
                ); // ← closing return
            }) : <>
                {!loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '65vh' }}>No history Available</div>}      </>}
            {loading && (
                <p style={{ textAlign: "center", padding: 10, fontSize: 13, color: "#555" }}>
                    Loading...
                </p>
            )}
        </div>
    );
}


const OccurrenceModal = ({show,showHistory,commChannelId,onHide,onHideHistory,textObj,emailObj,sentMail,isClientPermissions,closeModal,isCancelAMAFiled,
    isParamail,handleClick,refrencePage,setOpenId,historyData,openId,loading,selectedClient,lastItemRef,activationModal,sentActivationMail,userActivationData,replaceTemplate}) => {

    const [templateData,setTemplateData] = useState()


    const handleCancelClick = () => {
        onHide(false);
        if (refrencePage === 'occurence') {
            sessionStorage.setItem('isCancelAMA', 'true');
            if (isCancelAMAFiled) {
                closeModal();
            }
        }
        if(refrencePage == "sentEmail"){
            closeModal()
        }
    };

    const sendEmail =(data)=>{
           let textContentInfo = document.getElementById('emailtemplate2')?.innerHTML
           sentActivationMail(data,textContentInfo)
    }

    useEffect(() => {
        const subtenantId = sessionStorage.getItem("subtenantId");
        if (refrencePage == "sentEmail") {
            const results = Services.getEmailTemplatesUrlPathNew(4, true, subtenantId)
            results.then((res) => {
             setTemplateData(res?.data?.data?.[0])
            }).catch((err) => { })
        }
    },[refrencePage])

    return (
        <>
            {/* ── Global style — blurs the ENTIRE Modal 1 dialog (header + body) ── */}
            <style>{`
                .modal-blur-behind .modal-dialog {
                    filter: blur(3px);
                    pointer-events: none;
                    transition: filter 0.2s ease;
                }
                .modal-backdrop-blur {
                    backdrop-filter: blur(4px);
                    -webkit-backdrop-filter: blur(4px);
                    background-color: black !important;
                    transition: opacity 0.0s ease;
                }
               .modal-content{
               border-radius: 8px;
               }
               .modal-header .btn-close {
                width: 24px;
                height: 12px;
                opacity: 1;
              background-size: 11px;
               }
               .modal-body{
               padding:16px !important
               }
            `}</style>


            <Modal
                show={show}
                size="lg"
                centered
                onHide={handleCancelClick}
                backdrop="static"
                enforceFocus={false}
                backdropClassName="modal-backdrop-blur"
                className={showHistory ? "modal-blur-behind" : ""}
            >
                <Modal.Header closeButton closeVariant="Black" className="fw-bold" style={{fontSize:"16px",color:"#333"}}>
                    Preview Send {(commChannelId == 1) ? 'Email' : (commChannelId == 2) ? 'Text' : 'Email & Text'}
                </Modal.Header>

                <Modal.Body className="rounded">
                    {isParamail === true && (
                        <div className='d-flex justify-content-end mb-2 pe-3 cursor-pointer'>
                            <img
                                className="p-0 m-0"
                                width="20px"
                                height="auto"
                                src="/historyIcon.svg"
                                title="Email History"
                                onClick={() => handleClick()}
                            />
                        </div>
                    )}

                    <div
                        style={{ minHeight: "60vh", maxHeight: "60vh", height: "100vh", overflowX: "none", overflowY: "scroll", outline: "none" }}
                        className="border"
                        contentEditable
                    >
                        <div className="position-relative" id="emailtemplate" style={{ pointerEvents: "none" }}>
                            {!isNullUndefine(emailObj) && (
                                <>
                                    {isParamail !== true && <h6 className="ps-4 ms-5 mt-3">Email Template</h6>}
                                    <div
                                        id="emailTemplateEdit"
                                        contentEditable="true"
                                        dangerouslySetInnerHTML={{ __html: emailObj }}
                                        className="p-0 m-0"
                                    />
                                </>
                            )}
                            <div className="px-5 mb-2">
                                {!isNullUndefine(textObj) && (
                                    <>
                                        <h6 className="mt-3">Text Template</h6>
                                        {isClientPermissions === true
                                            ? <div contentEditable="true" id="textTemplateEdit" className="border p-2" style={{ padding: "10px 0 30px 0" }}>{textObj}</div>
                                            : <span className='ms-5 mt-2'>{'_$MSG._clientTextPermission'}</span>
                                        }
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end place-items-center pt-3 gap-2">
                          <button
                            style={{border:"1px solid #720C20",background:"transparent", borderRadius:"2px",height:"44px",padding: "10px 18px",fontSize:"14px",color:"#720C20" }}
                            className=""
                            onClick={handleCancelClick}
                                onMouseEnter={e => {
                                    e.currentTarget.style.background = "#720d21";
                                    e.currentTarget.style.color = "#fff";
                                    e.currentTarget.style.border = "1px solid #720d21";
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.background = "transparent";
                                    e.currentTarget.style.color = "#720d21";
                                    e.currentTarget.style.border = "1px solid #720d21";
                                }}
                        >
                            Cancel
                        </button>
                        <button
                            style={{borderRadius:"2px",height:"44px",padding: "10px 18px",fontSize:"14px"}}
                            className="add-user-btn"
                            onClick={() => sentMail()}
                        >
                            Send {(commChannelId == 1) ? 'Email' : (commChannelId == 2) ? 'Text' : 'Email & Text'}
                        </button>

                    </div>
                </Modal.Body>
            </Modal>

            {/* ══════════════════════════════════════════════
                Modal 2 — Email History
            ══════════════════════════════════════════════ */}
            <Modal
                show={showHistory}
                size="lg"
                centered
                onHide={() => onHideHistory(false)}
                backdrop="static"
                enforceFocus={false}
                backdropClassName="modal-backdrop-blur"
            >
                <Modal.Header closeButton closeVariant="Black" className="fw-bold"style={{fontSize:"16px",color:"#333"}}>
                    Email History ({selectedClient?.memberName})
                </Modal.Header>
                <Modal.Body className="rounded">
                    <div
                        style={{
                            minHeight: "74vh",
                            maxHeight: "74vh",
                            overflowY: "auto",
                            overflowX: "hidden",
                        }}
                    >
                        <EmailHistoryGrid
                            historyData={historyData}
                            openId={openId}
                            setOpenId={setOpenId}
                            loading={loading}
                            lastItemRef={lastItemRef}
                        />
                    </div>
                </Modal.Body>
            </Modal>



             <Modal
                show={activationModal}
                size="lg"
                centered
                onHide={handleCancelClick}
                backdrop="static"
                enforceFocus={false}
                backdropClassName="modal-backdrop-blur"
                className={showHistory ? "modal-blur-behind" : ""}
            >
                <Modal.Header closeButton closeVariant="Black" className="fw-bold" style={{fontSize:"16px",color:"#333"}}>
                    Preview Send {'Email'}
                </Modal.Header>

                <Modal.Body className="rounded">

                    <div
                        style={{ minHeight: "60vh", maxHeight: "60vh", height: "100vh", overflowX: "none", overflowY: "scroll", outline: "none" }}
                        className="border"
                        contentEditable
                    >
                        <div className="position-relative" id="emailtemplate2" style={{ pointerEvents: "none" }}>
                            {!isNullUndefine(templateData?.templateContent) && (
                                <>
                                    {/* {<h6 className="ps-4 ms-5 mt-3">Email Template</h6>} */}
                                    <div
                                        id="emailTemplateEdit"
                                        contentEditable="true"
                                        dangerouslySetInnerHTML={{ __html: replaceTemplate(templateData,userActivationData) }}
                                        className="p-0 m-0"
                                    />
                                </>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end place-items-center pt-3 gap-2">
                          <button
                            style={{border:"1px solid #720C20",background:"transparent", borderRadius:"2px",height:"44px",padding: "10px 18px",fontSize:"14px",color:"#720C20" }}
                            className=""
                            onClick={handleCancelClick}
                                onMouseEnter={e => {
                                    e.currentTarget.style.background = "#720d21";
                                    e.currentTarget.style.color = "#fff";
                                    e.currentTarget.style.border = "1px solid #720d21";
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.background = "transparent";
                                    e.currentTarget.style.color = "#720d21";
                                    e.currentTarget.style.border = "1px solid #720d21";
                                }}
                        >
                            Cancel
                        </button>
                        <button
                            style={{borderRadius:"2px",height:"44px",padding: "10px 18px",fontSize:"14px"}}
                            className="add-user-btn"
                            onClick={() => sendEmail(templateData)}
                        >
                            Send Email
                        </button>

                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default OccurrenceModal;

